import PropTypes from "prop-types";
import userType from "./userType";
import menuItemType from "./menuItemType";

export default PropTypes.shape({
  isPremiumEmployer: PropTypes.bool,
  markAllNotificationsReadUrl: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(menuItemType).isRequired,
  messagesUrl: PropTypes.string.isRequired,
  notificationsUrl: PropTypes.string.isRequired,
  unreadMessages: PropTypes.number.isRequired,
  unreadNotifications: PropTypes.number.isRequired,
  user: userType.isRequired,
});
